export default "__VITE_ASSET__1d3fbe7c__"